<router-outlet></router-outlet>

<app-text-popup></app-text-popup>

<app-spinner></app-spinner>
